import "./ContentWrapper.scss";

import { FC, ReactNode } from "react";

import c from "classnames";

interface IProps {
  className?: string;
  container?: boolean;
  children?: ReactNode;
}

export const ContentWrapper: FC<IProps> = ({ className, children, container = false }) => {
  const classNames = c("content-wrapper", className, {
    "content-container": container,
  });

  return <div className={classNames}>{children}</div>;
};
